// extracted by mini-css-extract-plugin
module.exports = {"container":"e_dA","widget":"e_eA","title":"e_fA","msrp":"e_gA","separator":"e_hA","textBadge":"e_iA"};